import { Kyp, KypComparator, KypDateField } from 'data/models/Kyp';

const getDateColumnForDateFields = (dateField?: KypDateField) => {
  switch (dateField) {
    case 'reviewDate':
      return { header: 'Last Reviewed', key: 'reviewDate' };
    case 'startTime':
      return { header: 'Created', key: 'startTime' };
    case 'lastUpdated':
    default:
      return { header: 'Last Updated', key: 'lastUpdated' };
  }
};

export const getKypTableColumns = (dateField?: KypDateField) => {
  const kypTableColumns = [
    { header: 'Security Name', key: 'name' },
    { header: 'Ticker', key: 'ticker' },
    { header: 'Approved For', key: 'approvedFor' },
  ];

  const dateColumn = getDateColumnForDateFields(dateField);

  kypTableColumns.push(dateColumn);
  kypTableColumns.push({ header: 'Status', key: 'reviewStatus' });

  return kypTableColumns;
};

const sortAlphabetical: KypComparator = (a: Kyp, b: Kyp) => a.name.localeCompare(b.name);
const sortTicker: KypComparator = (a: Kyp, b: Kyp) => a.ticker.localeCompare(b.ticker);

export const getKypSortingFunction = (sortBy: string, dateField: KypDateField): KypComparator => {
  switch (sortBy) {
    case 'Alphabetical':
      return sortAlphabetical;
    case 'Ticker':
      return sortTicker;
    case 'Oldest':
      return (a: Kyp, b: Kyp) => new Date(a[dateField]).getTime() - new Date(b[dateField]).getTime();
    case 'Newest':
    default:
      return (a: Kyp, b: Kyp) => new Date(b[dateField]).getTime() - new Date(a[dateField]).getTime();
  }
};
